/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_Toast_TitleInputs */



/**
* | output |
* | --- |
* | "OpenRift is installed" |
*
* @param {Install_Toast_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const install_toast_title = /** @type {((inputs?: Install_Toast_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Toast_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("OpenRift ist installiert")
	if (locale === "fr") return /** @type {LocalizedString} */ ("OpenRift est installé")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("OpenRift 已安装")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("OpenRift 已安裝")
	if (locale === "ko") return /** @type {LocalizedString} */ ("OpenRift가 설치되었어요")
	return /** @type {LocalizedString} */ ("OpenRift is installed")
});